import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';


export const tabStyles = makeStyles( ({
    tabsContainer: {
        borderBottom: `1px solid ${tcsmColors.greyFive}`,
        '& > button': {
            boxShadow: 'none',
            borderBottom: '2px solid transparent',
            borderRadius: '0',
            color: tcsmColors.blue,
            '&.Mui-disabled': {
                borderColor: tcsmColors.blue,
                color: tcsmColors.greyOne,
            },
            '&:hover': {
                boxShadow: 'none',
                borderBottom: '2px solid transparent',
            },
        },
    },

}));



